export enum MIMEType {
  json = 'application/json',
  form = 'application/x-www-form-urlencoded;charset=utf-8',
}

export enum RequestMethod {
  get = 'GET',
  post = 'POST',
  put = 'PUT',
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/http/request/enum.ts